export default __webpack_public_path__ + "static/media/cruiser.eb7614c8.jpg";